import React from 'react';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import { config } from '@src/framework/workbench/ui/font-size/config';
import { FormItemType } from '@src/framework/workbench/drawer/constants';
import { FONT_SIZE_DECREASE_ICON, FONT_SIZE_INCREASE_ICON } from '@src/framework/workbench/drawer/image';
import { ALIGN_BUTTON_STYLE } from '@src/framework/workbench/drawer/common/config';
import { config as fontIncreaseConfig } from '@src/framework/workbench/ui/font-size-increase/config';
import { config as fontDecreaseConfig } from '@src/framework/workbench/ui/font-size-decrease/config';

import Style from '@framework/workbench/drawer/ui/index.less';
import type { FormConfig } from '@tencent/wb-ext-form';

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.GLOBAL_FONT_SIZE,
        content: '',
        tooltip: config.tipMsg,
        preventFocus: true,
    },
    {
        type: FormItemType.BUTTON,
        name: ChartFormItemKey.GLOBAL_FONT_SIZE_ADD,
        options: {
            icon: <img src={FONT_SIZE_INCREASE_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: ALIGN_BUTTON_STYLE,
        tooltip: fontIncreaseConfig.tipMsg,
        preventFocus: true,
    },
    {
        type: FormItemType.BUTTON,
        name: ChartFormItemKey.GLOBAL_FONT_SIZE_SUBTRACT,
        options: {
            icon: <img src={FONT_SIZE_DECREASE_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: ALIGN_BUTTON_STYLE,
        tooltip: fontDecreaseConfig.tipMsg,
        preventFocus: true,
    },
];
